var map = {
	"./addliquidity.json": 1088,
	"./box.json": 1089,
	"./components.json": 1090,
	"./constants.json": 1091,
	"./error.json": 1092,
	"./farm.json": 1093,
	"./home.json": 1094,
	"./launchpad.json": 1095,
	"./menu.json": 1096,
	"./minning.json": 1097,
	"./nft.json": 1098,
	"./pool.json": 1099,
	"./referral.json": 1100,
	"./removeliquidity.json": 1101,
	"./rolling.json": 1102,
	"./swap.json": 1103,
	"./team.json": 1104,
	"./uikit.json": 1105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1087;